export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true},
 clients: {"default": {"httpEndpoint": "https://app.digiforma.com/api/v1/graphql", "tokenName": "apollo:emci.token", "tokenStorage": "cookie", "authType": "Bearer", "authHeader": "Authorization", "defaultOptions": undefined}}
}